import { Link } from "@mui/material";
import { Component } from "react";



export default class impressum extends Component
{


    render() {
        return(
        <>
            Earlydeskbird<br/>
            Trusted site - its security relies heavily on Unit-Tests<br/>
            <Link href='/' className="testKaputt">Earlydeskbird</Link>
        </>
        );
    }
}